import React, {
    useState
} from "react";
import PropTypes from "prop-types";

const DEFAULT_BORDER_COLOR = "#ced4da";
const FOCUSED_BORDER_COLOR = "#80bdff";
const INVALID_BORDER_COLOR = "#dc3545";
const DISABLED_BACKGROUND_COLOR = "#e9ecef";

function PasswordInput({
    className,
    disabled,
    id,
    name,
    value,
    onChange,
    onBlur,
    onFocus,
    autoComplete,
    ...props
}) {
    const [visible, setVisible] = useState(false);
    const [focused, setFocused] = useState(false);

    const invalid = className.includes("is-invalid");
    const borderColor = invalid
        ? INVALID_BORDER_COLOR
        : focused
            ? FOCUSED_BORDER_COLOR
            : DEFAULT_BORDER_COLOR;

    return (
        <div className="input-group">
            <input
                { ...props }
                type={ visible ? "text" : "password" }
                className={ className }
                disabled={ disabled }
                id={ id }
                name={ name }
                value={ value }
                onChange={ onChange }
                onFocus={ (event) => {
                    setFocused(true);
                    if(onFocus) {
                        onFocus(event);
                    }
                } }
                onBlur={ (event) => {
                    setFocused(false);
                    if(onBlur) {
                        onBlur(event);
                    }
                } }
                autoComplete={ autoComplete }
            />
            <div className="input-group-append">
                <button
                    type="button"
                    className="btn"
                    onClick={ () => setVisible((currentVisible) => !currentVisible) }
                    onMouseDown={ (event) => event.preventDefault() }
                    aria-label={ visible ? "Verberg wachtwoord" : "Toon wachtwoord" }
                    aria-pressed={ visible }
                    disabled={ disabled }
                    style={{
                        backgroundColor: disabled ? DISABLED_BACKGROUND_COLOR : "#ffffff",
                        borderColor,
                        borderLeft: 0,
                        color: borderColor
                    }}
                >
                    <i
                        className={ visible ? "fa-solid fa-eye-slash" : "fa-solid fa-eye" }
                        aria-hidden="true"
                    />
                </button>
            </div>
        </div>
    );
}

PasswordInput.propTypes = {
    autoComplete: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.string
};

PasswordInput.defaultProps = {
    autoComplete: undefined,
    className: "form-control",
    disabled: false,
    id: undefined,
    name: undefined,
    onBlur: undefined,
    onChange: undefined,
    onFocus: undefined,
    value: ""
};

export default React.memo(PasswordInput);
